import { render } from "./BeginSpeakerSection.vue?vue&type=template&id=20bb7ae7&scoped=true"
import script from "./BeginSpeakerSection.vue?vue&type=script&lang=js"
export * from "./BeginSpeakerSection.vue?vue&type=script&lang=js"

import "./BeginSpeakerSection.vue?vue&type=style&index=0&id=20bb7ae7&lang=scss&scoped=true"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-20bb7ae7"]])

export default __exports__